import React,{useCallback,useEffect,useState} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar, faUsers, faClock, faPlay, faRobot, faBrain, faChartLine, faCode, faProjectDiagram, faCloud, faCheckCircle, faDatabase, faServer, faLaptopCode, faCertificate, faBriefcase } from '@fortawesome/free-solid-svg-icons';
import './HeroSection.css';
 
const ProgrammingCourse = () => {
   const [showModal, setShowModal] = useState(false);
        const [formCourseName, setFormCourseName] = useState('programming');
        const [formData, setFormData] = useState({
          fullName: '',
          mobileNumber: '',
          email: '',
        });
      
        const openModal = () => setShowModal(true);
        const closeModal = useCallback(() => {
          setShowModal(false);
          setFormData({ fullName: '', mobileNumber: '', email: '' });
        }, []);
      
        useEffect(() => {
          const handleEsc = (e) => {
            if (e.key === 'Escape') closeModal();
          };
          window.addEventListener('keydown', handleEsc);
          return () => window.removeEventListener('keydown', handleEsc);
        }, [closeModal]);
      
        const handleInputChange = (e) => {
          const { name, value } = e.target;
          if (name === 'mobileNumber') {
            const digitsOnly = value.replace(/\D/g, '');
            if (digitsOnly.length <= 10) {
              setFormData(prev => ({ ...prev, [name]: digitsOnly }));
            }
          } else {
            setFormData(prev => ({ ...prev, [name]: value }));
          }
        };
      
        const handleSubmit = async (e) => {
          e.preventDefault();
          const { fullName, mobileNumber, email } = formData;
      
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
          if (!fullName || !emailRegex.test(email) || mobileNumber.length !== 10) {
            alert('Please fill in valid details.');
            return;
          }
      
          try {
            const response = await fetch('https://api.dikshasea.in/api/enrollments', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ ...formData, course: formCourseName }),
            });
      
            const result = await response.json();
            if (response.ok) {
              alert('Enrollment successful!');
              closeModal();
            } else {
              alert(result.message || 'Submission failed');
            }
          } catch (err) {
            console.error(err);
            alert('Error submitting form');
          }
        };
      
  return (
    <>
      <section className="hero-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h1 className="hero-title">
                Master <span className="hero-highlight">Programming Fundamentals</span>
              </h1>
              <p className="hero-subtitle">
                Build a strong foundation in programming with our comprehensive course designed for beginners and intermediate learners.
                Learn core concepts, best practices, and gain hands-on experience with real coding projects.
              </p>
             
              <div className="course-meta">
                <div className="meta-item">
                  <div className="meta-icon">
                    <FontAwesomeIcon icon={faStar} />
                  </div>
                  <div>
                    <div className="fw-bold">4.8/5.0</div>
                    <small className="text-muted">(3,120 reviews)</small>
                  </div>
                </div>
                <div className="meta-item">
                  <div className="meta-icon">
                    <FontAwesomeIcon icon={faUsers} />
                  </div>
                  <div>
                    <div className="fw-bold">12,500+</div>
                    <small className="text-muted">Students</small>
                  </div>
                </div>
                <div className="meta-item">
                  <div className="meta-icon">
                    <FontAwesomeIcon icon={faClock} />
                  </div>
                  <div>
                    <div className="fw-bold">60 hours</div>
                    <small className="text-muted">Content</small>
                  </div>
                </div>
              </div>
             
              <div className="d-flex flex-wrap gap-3">
                <a href="/register" className="btn btn-primary btn-lg px-4">Enroll Now</a>
                {/* <button className="btn btn-outline-primary btn-lg px-4" data-bs-toggle="modal" data-bs-target="#previewModal">
                  <FontAwesomeIcon icon={faPlay} className="me-2" />
                  Preview Course
                </button> */}
              </div>
            </div>
            <div className="col-lg-6 mt-5 mt-lg-0">
              <div className="ratio ratio-16x9">
                <img
                  src="subcourses/programming.jpg"
                  alt="Programming Course"
                  className="img-fluid rounded-3 shadow"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
     <div className="container">
      <div className="course-details">
        <div className="course-content">
          {/* About Course */}
          <section className="about-course">
            <h2 className="section-title">About This Course</h2>
            <p>This comprehensive Programming Fundamentals course will take you from absolute beginner to confident coder. You'll learn core programming concepts, problem-solving techniques, and multiple programming languages.</p>
            <p>Through hands-on coding exercises and projects, you'll build a portfolio demonstrating your skills in Python, JavaScript, and other modern programming languages.</p>
          </section>
         
          {/* Curriculum */}
          <section className="curriculum">
            <h2 className="section-title">Curriculum</h2>
           
            <div className="curriculum-item">
              <h3><FontAwesomeIcon icon={faCode} className="me-2" /> Module 1: Programming Basics</h3>
              <p>Learn the fundamental concepts that apply to all programming languages</p>
              <div className="topics">
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Variables and data types</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Control structures (loops, conditionals)</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Functions and modular programming</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Basic algorithms and problem solving</div>
              </div>
            </div>
           
            <div className="curriculum-item">
              <h3><FontAwesomeIcon icon={faLaptopCode} className="me-2" /> Module 2: Python Programming</h3>
              <p>Master one of the most versatile and beginner-friendly programming languages</p>
              <div className="topics">
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Python syntax and semantics</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Object-oriented programming</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Working with files and APIs</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Popular Python libraries</div>
              </div>
            </div>
           
            <div className="curriculum-item">
              <h3><FontAwesomeIcon icon={faDatabase} className="me-2" /> Module 3: Data Structures & Algorithms</h3>
              <p>Learn how to organize and manipulate data efficiently</p>
              <div className="topics">
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Arrays, lists, and dictionaries</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Stacks, queues, and linked lists</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Sorting and searching algorithms</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Time and space complexity</div>
              </div>
            </div>
           
            <div className="curriculum-item">
              <h3><FontAwesomeIcon icon={faProjectDiagram} className="me-2" /> Module 4: Web Development Basics</h3>
              <p>Introduction to building web applications</p>
              <div className="topics">
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> HTML5 and CSS3 fundamentals</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> JavaScript programming</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> DOM manipulation</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Basic frontend frameworks</div>
              </div>
            </div>
           
            <div className="curriculum-item">
              <h3><FontAwesomeIcon icon={faServer} className="me-2" /> Module 5: Capstone Project</h3>
              <p>Build a complete application from scratch</p>
              <div className="topics">
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Project planning and design</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Implementation and testing</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Debugging and optimization</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Deployment and documentation</div>
              </div>
            </div>
          </section>
        </div>  
       
        <div className="course-sidebar">
          <div className="info-item">
            <div className="info-icon">
              <FontAwesomeIcon icon={faClock} />
            </div>
            <div className="info-content">
              <h4>Duration</h4>
              <p>10 Weeks (15 hrs/week)</p>
            </div>
          </div>
         
          <div className="info-item">
            <div className="info-icon">
              <FontAwesomeIcon icon={faCertificate} />
            </div>
            <div className="info-content">
              <h4>Level</h4>
              <p>Beginner to Intermediate</p>
            </div>
          </div>
         
          <div className="info-item">
            <div className="info-icon">
              <FontAwesomeIcon icon={faLaptopCode} />
            </div>
            <div className="info-content">
              <h4>Projects</h4>
              <p>6 Coding Projects</p>
            </div>
          </div>
         
          <div className="info-item">
            <div className="info-icon">
              <FontAwesomeIcon icon={faUsers} />
            </div>
            <div className="info-content">
              <h4>Prerequisites</h4>
              <p>Basic computer skills</p>
            </div>
          </div>
         
          <div className="info-item">
            <div className="info-icon">
              <FontAwesomeIcon icon={faBriefcase} />
            </div>
            <div className="info-content">
              <h4>Career Support</h4>
              <p>Portfolio reviews, Coding interviews</p>
            </div>
          </div>
         
          <a href="/register" className="enroll-button" style={{display: 'block', textAlign: 'center', marginTop: '2rem'}}>
            Enroll Now
          </a>
        </div>
      </div>
    </div>
    {/* MODAL */}
      {showModal && (
        <div
          className="modal d-block fade show"
          style={{ background: 'rgba(0,0,0,0.5)' }}
          onClick={(e) => { if (e.target === e.currentTarget) closeModal(); }}
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content p-4 d-flex flex-column flex-md-row">
              <div className="w-100 w-md-50 mb-3 mb-md-0">
                <img
                  src="/img/enroll.jpg"
                  alt="Enrollment"
                  className="img-fluid h-100"
                  style={{ objectFit: 'cover', width: '100%' }}
                />
              </div>
              <div className="w-100 w-md-50 ps-md-4">
                <h6 className="text-primary">Course:</h6>
                <h4 className="fw-bold">{formCourseName}</h4>
                <form onSubmit={handleSubmit} noValidate>
                  <input
                    className="form-control mb-3"
                    type="text"
                    name="fullName"
                    placeholder="Full Name"
                    value={formData.fullName}
                    onChange={handleInputChange}
                    required
                  />
                  <input
                    className="form-control mb-3"
                    type="text"
                    name="mobileNumber"
                    placeholder="Mobile Number"
                    value={formData.mobileNumber}
                    onChange={handleInputChange}
                    required
                    maxLength={10}
                  />
                  <input
                    className="form-control mb-3"
                    type="email"
                    name="email"
                    placeholder="Email Address"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                  />
                  <div className="d-flex justify-content-end">
                    <button type="button" className="btn btn-outline-dark me-2" onClick={closeModal}>
                      Cancel
                    </button>
                    <button type="submit" className="btn btn-primary">Submit</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
 
export default ProgrammingCourse;